import { render, staticRenderFns } from "./MovementPanel.vue?vue&type=template&id=d3b2489c"
import script from "./MovementPanel.vue?vue&type=script&lang=ts"
export * from "./MovementPanel.vue?vue&type=script&lang=ts"
import style0 from "./MovementPanel.vue?vue&type=style&index=0&id=d3b2489c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports